import { render, staticRenderFns } from "./BuildingBasicData.vue?vue&type=template&id=57c55d7b"
import script from "./BuildingBasicData.vue?vue&type=script&lang=js"
export * from "./BuildingBasicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports